(() => {
  const page = document.querySelector('.tis-reviews-page');
  const summaries = [...document.querySelectorAll('[data-review-summary]')];
  if (!page && summaries.length === 0) return;

  const controls = page?.querySelector('[data-review-controls]');
  const list = page?.querySelector('[data-review-list]');
  let cards = [...(page?.querySelectorAll('[data-review-card]') || [])];
  const feedUrl = page?.dataset.reviewFeedUrl;

  const text = (value) => String(value ?? '');
  const formatDate = (value) => {
    const date = new Date(value);
    return Number.isNaN(date.valueOf()) ? '' : date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const syncSummaryHistograms = () => {
    summaries.forEach((summary) => {
      const sourceData = summary.querySelector('[data-review-source-data]');
      if (!sourceData) return;

      for (const rating of ['5', '4', '3', '2', '1']) {
        const sourceRow = sourceData.querySelector(`[data-rating="${rating}"]`);
        const targetRow = summary.querySelector(`[data-rating="${rating}"]`);
        if (!sourceRow || !targetRow) continue;

        const percent = sourceRow.getAttribute('data-percentage') || '0';
        const frequency = sourceRow.getAttribute('data-frequency') || '0';
        const track = targetRow.querySelector('.tis-review-proof__histogram-track > span');
        const label = targetRow.querySelector('.tis-review-proof__histogram-percent');

        targetRow.dataset.frequency = frequency;
        targetRow.setAttribute('aria-label', `${frequency} reviews, ${percent}%`);
        if (track) track.style.width = `${percent}%`;
        if (label) label.textContent = `${percent}%`;
      }
    });
  };

  const makeCard = (review) => {
    const card = document.createElement('article');
    card.className = 'tis-review-card';
    card.dataset.reviewCard = '';
    card.dataset.reviewRating = String(review.rating);

    const topLine = document.createElement('div');
    topLine.className = 'tis-review-card__topline';
    const name = document.createElement('span');
    name.className = 'tis-review-card__name';
    name.textContent = text(review.reviewerName);
    topLine.append(name);
    if (review.sourceLabel) {
      const source = document.createElement('span');
      source.className = 'tis-review-card__source';
      source.textContent = text(review.sourceLabel);
      topLine.append(source);
    }
    card.append(topLine);

    const rating = document.createElement('div');
    rating.className = 'tis-review-card__rating';
    rating.setAttribute('aria-label', `${review.rating} out of 5 stars`);
    rating.textContent = '★'.repeat(Math.max(1, Math.min(5, Number(review.rating) || 0)));
    card.append(rating);

    const body = document.createElement('p');
    body.className = 'tis-review-card__body';
    body.textContent = text(review.body);
    card.append(body);

    const footer = document.createElement('div');
    footer.className = 'tis-review-card__footer';
    const date = document.createElement('time');
    date.dateTime = text(review.createdAt);
    date.textContent = formatDate(review.createdAt);
    footer.append(date);
    if (review.productTitle) {
      const product = document.createElement('span');
      product.title = text(review.productTitle);
      product.textContent = text(review.productTitle);
      footer.append(product);
    }
    card.append(footer);
    return card;
  };

  const sync = () => {
    syncSummaryHistograms();
    const rating = new URLSearchParams(window.location.search).get('rating');
    const selectedRating = rating && /^[1-5]$/.test(rating) ? rating : 'all';

    controls?.querySelectorAll('[data-review-rating]').forEach((link) => {
      link.classList.toggle('is-active', link.dataset.reviewRating === selectedRating);
      if (link.dataset.reviewRating === selectedRating) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });

    cards.forEach((card) => {
      card.hidden = selectedRating !== 'all' && card.dataset.reviewRating !== selectedRating;
    });
  };

  const renderFeed = (reviews) => {
    if (!list) return;
    list.replaceChildren(...reviews.map(makeCard));
    cards = [...list.querySelectorAll('[data-review-card]')];
    sync();
  };

  const loadFeed = async () => {
    if (!feedUrl || !list) return;
    try {
      const response = await fetch(feedUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!response.ok) return;
      const payload = await response.json();
      if (payload.ok && Array.isArray(payload.reviews) && payload.reviews.length > 0) renderFeed(payload.reviews);
    } catch {
      // Keep the server-rendered fallback cards when the proxy is unavailable.
    }
  };

  controls?.addEventListener('click', (event) => {
    const link = event.target.closest('[data-review-rating]');
    if (!link) return;
    event.preventDefault();
    const url = new URL(link.href, window.location.href);
    window.history.pushState({}, '', url);
    sync();
  });
  window.addEventListener('popstate', sync);
  sync();
  loadFeed();
})();